import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import AddBeneficiaryBankDetails from '@components/AddBeneficiaryBankDetails';
import AddBuyerAddress from '@components/AddBuyerAddress';
import CustomDropdown from '@components/CustomDropdown';
import NoData from '@components/NoData';
import TimeBasedLoader from '@components/TimeBasedLoader';
import { toastError, toastSuccess } from '@components/Toast';
import LoaderComponent from '@components/LoaderComponent';

import EditSalesContruct from '@features/order/components/commercial-invoice/EditSalesContruct';
import OrderWiseSupplier from '@features/order/components/OrderWiseSupplier';

import {
	fetchBeneficiaryList as fetchBuyerBillingLits,
	fetchBrandLocaionList,
	fetchInvoiceDetails,
	fetchNitexBankDetails,
	fetchOrderPlaceWorkflow
} from '@store/orders/actions';
import {
	getBeneficiaryList as getBuyerBillingLits,
	getBrandLocationList,
	getNitexBankDetails,
	getSalesContractDetails
} from '@store/reducers';
import { fetchSalesContractDetails } from '@store/salesContract/actions';

import { fetchAllAmendments, getAmendmentWiseSalesContruct } from '@services/salesContructService';

import ApiClient from '@lib/apiClient';

import {
	_getKey,
	changeDateFormat,
	checkAnyUserType,
	convertNumberToUSFormat,
	getShortName,
	isValidFile,
	isValidInput,
	packTag,
	setTag,
	validateFloatNumber,
	validateNumber
} from '@utils/Util';

import { BASE_URL, VALID_FILE_SIZE } from '@/constants/constant';

const locationTypes = [
	{ id: 1, name: 'Factory location', type: 'FACTORY' },
	{ id: 2, name: 'Office location', type: 'OFFICE' }
];

const SalesContract = ({ orderId }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [isMaterialListLoading, setIsMaterialListLoading] = useState(false);
	const [supplierList, setSupplierList] = useState([]);
	const [, setInitialLoading] = useState(false);
	const [selectedBuyerBillingAddress, setSelectedBuyerBillingAddress] = useState('');
	const [selectedBuyerBankDetails, setSelectedBuyerBankDetails] = useState('');
	const [selectedBuyerConsignee, setSelectedBuyerConsignee] = useState('');
	const [selectedBeneficiaryDetails, setSelectedBeneficiaryDetails] = useState('');
	const [selectedBeneficiaryBankDetails, setSelectedBeneficiaryBankDetails] = useState('');
	const [isAddBeneficiaryBank, setIsAddBeneficiaryBank] = useState(false);
	const [salesContractDetails, setSalesContractDetails] = useState(null);
	const [salesContractId, setSalesContractId] = useState(null);
	const [cellId, setCellId] = useState('');
	const [, setIsUpdateOrder] = useState(false);
	const [isAddNewOrder] = useState(false);
	const [supplierBankDetailsList, setSupplierBankDetailsList] = useState([]);
	const [startLoader, setStartLoader] = useState(false);
	const [newTermCellId, setNewTermCellId] = useState('');
	const [, setIsUpdateTerm] = useState(false);
	const [isAddNewTerm, setIsAddNewTerm] = useState(false);
	const [, setIsUpdateNotify] = useState(false);
	const [isAddAddress, setIsAddAddress] = useState(false);
	const dispatch = useDispatch();
	let salesContractInfo = useSelector(getSalesContractDetails);
	let brandLocationList = useSelector(getBrandLocationList);
	let buyerBillingLits = useSelector(getBuyerBillingLits);
	let nitexBankDetails = useSelector(getNitexBankDetails);
	const prevTarget = useRef(null);
	const location = useLocation();
	const [isEditContructDetails, setIsEditContructDetails] = useState(false);
	const [amendmentList, setAmendmentList] = useState([]);
	const [selectedAmendment, setSelectedAmendment] = useState('');
	const [amendmentOrderSummary, setAmendmentOrderSummary] = useState([]);
	const [notifyParty, setNotifyParty] = useState('');

	const getSalesContractDetailsInfo = (id) => {
		setInitialLoading(true);
		dispatch(fetchSalesContractDetails(id)).finally(() => {
			setInitialLoading(false);
		});
	};

	const getAllAmendments = async () => {
		const data = await fetchAllAmendments(salesContractDetails?.salesContractId);
		setAmendmentList([
			{
				id: 'FIRST_COPY',
				salesContractId: salesContractDetails?.salesContractId,
				amendmentId: null,
				value: 'First Copy'
			},
			...data
		]);
	};

	useEffect(() => {
		if (salesContractDetails?.salesContractId) getAllAmendments();
	}, [salesContractDetails?.salesContractId]);

	useEffect(() => {
		setInitialLoading(true);
		dispatch(fetchBuyerBillingLits()).finally(() => {
			setInitialLoading(false);
		});
		dispatch(fetchNitexBankDetails()).finally(() => {
			setInitialLoading(false);
		});
		getSupplierList(orderId, true);
	}, [orderId]);

	useEffect(() => {
		if (salesContractInfo?.id) {
			setSalesContractDetails(salesContractInfo);
			dispatch(fetchBrandLocaionList(salesContractInfo?.brandId));
			getSupplierBankDetailsList(salesContractInfo?.supplierId);
		}
	}, [salesContractInfo, salesContractInfo?.id]);

	useEffect(() => {
		setSelectedBuyerBillingAddress(salesContractDetails?.billingAddress?.title);
		setSelectedBeneficiaryDetails(salesContractDetails?.beneficiaryDetails?.type);
		setSelectedBuyerBankDetails(salesContractDetails?.buyerBankDetails?.title);
		setSelectedBeneficiaryBankDetails(salesContractDetails?.beneficiaryBankDetails?.bankName);
		setSelectedBuyerConsignee(salesContractDetails?.consignee?.id);
		setSalesContractId(salesContractDetails?.id);
		setNotifyParty(
			salesContractDetails && salesContractDetails.notifyParty ? salesContractDetails.notifyParty : ''
		);
	}, [salesContractDetails]);

	const getSupplierList = async (id, isInitialRender = false) => {
		setIsMaterialListLoading(true);
		await ApiClient.GET('getAllSupplierList', id)
			.then(({ data }) => {
				setIsMaterialListLoading(false);
				setSupplierList(data);
				if (isInitialRender) {
					let scId = new URLSearchParams(location.search).get('scId');
					if (scId) {
						return getSalesContractDetailsInfo(scId);
					}
					return getSalesContractDetailsInfo(data[0].id);
				}
			})
			.catch(({ response }) => {
				setIsMaterialListLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				}
			});
	};

	const onUpdateSalesContact = async (body) => {
		setIsLoading(true);
		await ApiClient.PUT('updateSalesContract', body, salesContractId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					setIsUpdateNotify(false);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					toastSuccess(data.message);
					getSalesContractDetailsInfo(salesContractId);
					setSalesContractDetails({ ...salesContractDetails, notifyParty: '' });
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUpdateBuyerConsignee = async (locationId, salesContractId) => {
		setIsLoading(true);
		const params = `${salesContractId}/${locationId}`;
		await ApiClient.POST('updateBillingConsignee', {}, params)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUpdateBuyerBillingList = async (item, salesContractId) => {
		setIsLoading(true);
		await ApiClient.POST('updateBillingAddress', { ...item }, salesContractId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUpdateBeneficiaryDetails = async (item, salesContractId, type) => {
		setIsLoading(true);
		let params = `${salesContractId}?locationType=${type}`;
		await ApiClient.POST('updateBeneficiaryDetails', { ...item }, params)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUpdateBuyerBankDetails = async (item, salesContractId) => {
		setIsLoading(true);
		await ApiClient.POST('updateBuyerBankDetails', { ...item }, salesContractId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUpdateBeneficiaryBankDetails = async (item) => {
		setIsLoading(true);
		const params = `${salesContractId}/${item.id}`;
		await ApiClient.POST('updateBeneficiaryBankDetails', {}, params)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const getSupplierBankDetailsList = async (id) => {
		setIsLoading(true);
		await ApiClient.GET('getSupplierBankDetailsList', id)
			.then(({ data }) => {
				setIsLoading(false);
				setSupplierBankDetailsList(data);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Something went wrong! Please try again.');
				}
			});
	};

	const onUpdateItemToOrder = async (item) => {
		setIsLoading(true);
		const body = {
			name: item.itemName,
			quantity: item.quantity,
			unitPrice: item.unitPrice
		};
		await ApiClient.PUT('updateOrderSummary', { ...body }, item.id)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onAddItemToOrder = async (item) => {
		setIsLoading(true);
		const body = {
			name: item.itemName,
			quantity: item.quantity,
			unitPrice: item.unitPrice
		};
		await ApiClient.POST('addNewOrderSummary', { ...body }, salesContractId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onRemoveOrder = async (item, idx) => {
		setIsLoading(true);
		if (!item.id) {
			setIsLoading(false);
			const newData = { ...salesContractDetails };
			const orderItem = newData['salesContractItemResponseList'];
			const updatedItems = orderItem.splice(idx, 1);
			newData[idx] = updatedItems;
			setSalesContractDetails(newData);
			return;
		}
		await ApiClient.DELETE('deleteOrderSummary', {}, item.id)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onAddTermsToSalesContract = async (item) => {
		setIsLoading(true);
		const body = {
			terms: item.term,
			termDetails: item.termDetails
		};
		await ApiClient.POST('addTermToSalesContract', { ...body }, salesContractId)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onUpdateTerms = async (item) => {
		setIsLoading(true);
		const body = {
			terms: item.term,
			termDetails: item.termDetails
		};
		await ApiClient.PUT('updateTerm', { ...body }, item.id)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					dispatch(fetchOrderPlaceWorkflow(orderId));
					getSalesContractDetailsInfo(salesContractId);
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onAddBeneficiaryBank = () => {
		setIsAddBeneficiaryBank(!isAddBeneficiaryBank);
	};

	const onChangeOrder = (e, idx) => {
		let { id, value } = e.target;
		const newData = { ...salesContractDetails };
		const orderItem = newData['salesContractItemResponseList'];
		if (id === 'quantity') {
			orderItem[idx][id] = value;
		} else {
			orderItem[idx][id] = value;
		}
		newData[idx] = orderItem;
		setSalesContractDetails(newData);
	};

	const onAddNewTerms = () => {
		let otherItem = { isDeleted: false, term: '', termDetails: '' };
		const newItem = {
			...salesContractDetails,
			termsAndConditionsResponseList: [
				...salesContractDetails.termsAndConditionsResponseList,
				otherItem
			]
		};
		setSalesContractDetails(newItem);
		const index = newItem.termsAndConditionsResponseList.length;
		setNewTermCellId(`${index - 1}-newItem`);
		setIsAddNewTerm(true);
	};

	const onChangeAddNewTerms = (e, idx) => {
		let { id, value } = e.target;
		const newData = { ...salesContractDetails };
		const termsItem = newData['termsAndConditionsResponseList'];
		termsItem[idx][id] = value;
		newData[idx] = termsItem;
		setSalesContractDetails(newData);
	};

	const onAddTerms = (item) => {
		if (item.term !== '' && item.termDetails !== '') {
			if (item.id) {
				onUpdateTerms(item);
				setNewTermCellId('');
				setIsUpdateTerm(false);
			} else {
				onAddTermsToSalesContract(item);
				setNewTermCellId('');
			}
		}
	};

	const onAddNewOrderSummary = (item) => {
		if (item.itemName && item.quantity && item.unitPrice) {
			if (item.id) {
				onUpdateItemToOrder(item);
				setCellId('');
				setIsUpdateOrder(false);
			} else {
				onAddItemToOrder(item);
				setCellId('');
			}
		}
	};

	const onChangeTerms = async (item) => {
		setIsLoading(true);
		const params = `?termIdList=${[item.id]}&isDeleted=${!item.isDeleted}`;
		await ApiClient.DELETE('deleteTerm', {}, params)
			.then(({ data }) => {
				setIsLoading(false);
				if (data && data.success) {
					toastSuccess(data.message);
					// dispatch(fetchOrderPlaceWorkflow(orderId));
					let updatedList = salesContractDetails?.termsAndConditionsResponseList?.map((term) => {
						if (term.id === item.id) {
							term.isDeleted = !term.isDeleted;
						}
						return term;
					});
					setSalesContractDetails({
						...salesContractDetails,
						termsAndConditionsResponseList: updatedList
					});
				}
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onDownload = async () => {
		setStartLoader(true);
		await ApiClient.GET('downloadSalesContract', salesContractId)
			.then((response) => {
				if (response.data) {
					window.open(response.data, '_parent');
				}
				getSupplierList(orderId, false);
				getSalesContractDetailsInfo(salesContractId);
				dispatch(fetchOrderPlaceWorkflow(orderId));
				setStartLoader(false);
			})
			.catch((error) => {
				toastError(error.response.data.message);
				setStartLoader(false);
			});
	};

	const onSelectAmendment = async (item) => {
		setSelectedAmendment(item);
		const data = await getAmendmentWiseSalesContruct(
			item?.salesContractId,
			item?.amendmentId,
			setIsLoading
		);
		setAmendmentOrderSummary(data);
	};

	useEffect(() => {
		if (salesContractDetails?.salesContractId && salesContractDetails?.amendmentId) {
			onSelectAmendment(salesContractDetails);
		}
	}, [salesContractDetails?.salesContractId, salesContractDetails?.amendmentId]);

	useEffect(() => {
		if (!salesContractDetails?.amendmentId) {
			setSelectedAmendment({
				id: 'FIRST_COPY',
				salesContractId: salesContractDetails?.salesContractId,
				amendmentId: null,
				amendmentNo: 'First Copy'
			});
		}
	}, [salesContractDetails]);

	const renderProductOrders = (item) => {
		return (
			<>
				<td>
					{item?.mergedFromOrderId ? (
						<Tooltip title="Go to PI" placement="top" arrow>
							<Link
								to={`/orders/view/${item?.mergedFromOrderId}?workTab=Sales contract&routeFrom=SCPI&scId=${item?.mergedFromSCId}`}
							>
								<p className="gray_dark_02 mb-0">PO# {item?.poNumber}</p>
								<p className="gray_dark_02 mb-0">{item?.referenceNumber}</p>
							</Link>
						</Tooltip>
					) : (
						<>
							<div className="mb-1">
								{item?.isSet && setTag()} {item?.isPack && packTag()}
							</div>
							<p className="gray_dark_02 mb-0">PO# {item?.poNumber}</p>
							<p className="gray_dark_02 mb-0">{item?.referenceNumber}</p>
						</>
					)}
				</td>
				<td>
					{item?.isSet ? (
						<div>
							{item?.setMemberResponseList && <p>{item?.setMemberResponseList[0]?.market}</p>}
							{item?.setMemberResponseList?.map((memberCategory, index) => (
								<span className="gray_dark_02" key={_getKey()}>
									{`${memberCategory?.itemName}${
										index !== item?.setMemberResponseList.length - 1 ? ',' : ''
									} `}
								</span>
							))}
						</div>
					) : (
						<p className="gray_dark_02 mb-0">
							{item?.market && `${item?.market}, `}
							{item?.itemName}
						</p>
					)}

					<p className="gray_dark_02 mb-0">{item?.sizes}</p>
				</td>
				<td>
					<span className="gray_dark_02">{item?.colors}</span>
				</td>
				<td>
					<span className="gray_dark_01">
						{changeDateFormat(item?.deliveryDate, '', 'Do MMM, YY')}
					</span>
				</td>
				<td>
					<span className="gray_dark_02">{item?.quantity}</span>
				</td>
				<td>
					<span className="gray_dark_02">{item?.unitPrice}</span>
				</td>
				<td>
					<span className="gray_dark_02">{convertNumberToUSFormat(item?.totalPrice)}</span>
				</td>
			</>
		);
	};

	const renderOtherOrders = (item, idx) => {
		return (
			<>
				<td />
				<td
					className="cursor-pointer"
					onClick={() => {
						setCellId(`${idx}-newItem`);
						setIsUpdateOrder(true);
					}}
				>
					<span className="gray_dark_02" />

					{cellId === `${idx}-newItem` || (isAddNewOrder && cellId === `${idx}-newItem`) ? (
						<input
							type="text"
							autoComplete="off"
							id="itemName"
							value={item.itemName}
							onChange={(e) => onChangeOrder(e, idx)}
							onFocus={(event) => (prevTarget.current = event.target.value)}
							onBlur={(event) => {
								if (!isValidInput(prevTarget, event)) {
									resetAll();
									return;
								}
								onAddNewOrderSummary(item, idx);
							}}
						/>
					) : (
						<span className="gray_dark_02">{item?.itemName}</span>
					)}
				</td>
				<td />
				<td />
				<td
					className="cursor-pointer"
					onClick={() => {
						setCellId(`${idx}-newItem`);
						setIsUpdateOrder(true);
					}}
				>
					{cellId === `${idx}-newItem` || (isAddNewOrder && cellId === `${idx}-newItem`) ? (
						<input
							type="number"
							id="quantity"
							placeholder="0"
							min={1}
							value={isNaN(item.quantity) ? null : item.quantity}
							onChange={(e) => onChangeOrder(e, idx)}
							onFocus={(event) => (prevTarget.current = event.target.value)}
							onBlur={(event) => {
								if (!isValidInput(prevTarget, event)) {
									resetAll();
									return;
								}
								onAddNewOrderSummary(item, idx);
							}}
							onKeyPress={validateNumber}
						/>
					) : (
						<>
							<span className="gray_dark_02" />
							<span className="gray_dark_02">{item?.quantity}</span>
						</>
					)}
				</td>
				<td
					className="cursor-pointer"
					onClick={() => {
						setCellId(`${idx}-newItem`);
						setIsUpdateOrder(true);
					}}
				>
					{cellId === `${idx}-newItem` || (isAddNewOrder && cellId === `${idx}-newItem`) ? (
						<input
							type="number"
							id="unitPrice"
							placeholder="0"
							min={1}
							value={isNaN(item.unitPrice) ? null : item.unitPrice}
							onKeyPress={validateFloatNumber}
							onChange={(e) => onChangeOrder(e, idx)}
							onFocus={(event) => (prevTarget.current = event.target.value)}
							onBlur={(event) => {
								if (!isValidInput(prevTarget, event)) {
									resetAll();
									return;
								}
								onAddNewOrderSummary(item, idx);
							}}
						/>
					) : (
						<>
							<span className="gray_dark_02" />
							<span className="gray_dark_02">{item?.unitPrice}</span>
						</>
					)}
				</td>
				<td>
					<div className="d-flex">
						<span className="gray_dark_02">
							{convertNumberToUSFormat(parseFloat(item.quantity * item.unitPrice))}
						</span>
						<img
							src={`${process.env.PUBLIC_URL}/icons/delete_gray.svg`}
							className="ml-2"
							alt="delete"
							onClick={() => onRemoveOrder(item, idx)}
						/>
					</div>
				</td>
			</>
		);
	};

	const getItemTotal = (items) => {
		return items?.reduce((total, item) => {
			return parseInt(total) + parseInt(item.quantity);
		}, 0);
	};
	const getTotalAmount = (items) => {
		return items?.reduce((total, item) => {
			return parseFloat(total) + parseFloat(item?.totalPrice);
		}, 0);
	};

	const resetAll = () => {
		prevTarget.current = null;
		setCellId('');
		setNewTermCellId('');
		setIsUpdateTerm(false);
		setIsUpdateNotify(false);
	};

	const onSalesContaractClick = (item) => {
		if (salesContractDetails.id !== item.id) {
			getSalesContractDetailsInfo(item.id);
		}
	};
	const getSelectedBuyerConsignee = () => {
		return brandLocationList.find((item) => item.id == selectedBuyerConsignee)?.title || 'Select address';
	};

	const getInvoiceDetailsInfo = (invoiceId) => {
		dispatch(fetchInvoiceDetails(invoiceId)).finally(() => {
			setInitialLoading(false);
		});
	};

	const onAddConsigneeAddress = () => {
		setIsAddAddress(!isAddAddress);
	};

	const onFileUpload = (e) => {
		let file = e.target.files[0];
		if (isValidFile(file, 'imageAndPdf', VALID_FILE_SIZE)) {
			let data = {
				name: file.name,
				docMimeType: file.type,
				documentType: 'SUPPLIER_SIGNED_PI',
				base64Str: '',
				size: file.size
			};
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				data.base64Str = reader.result;
				onAdd(data);
			};
			reader.onerror = function (error) {
				toastError(error);
			};
		}
	};

	const onNitexScUpload = (e) => {
		let file = e.target.files[0];
		if (isValidFile(file, 'imageAndPdf', VALID_FILE_SIZE)) {
			let data = {
				name: file.name,
				docMimeType: file.type,
				documentType: 'NITEX_SIGNED_SC',
				base64Str: '',
				size: file.size
			};
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => {
				data.base64Str = reader.result;
				onAdd(data);
			};
			reader.onerror = function (error) {
				toastError(error);
			};
		}
	};

	const onAdd = async (data) => {
		setIsLoading(true);
		await ApiClient.POST(
			`${BASE_URL}/sales-contract/${salesContractDetails.id}/add-payment-doc`,
			data,
			'',
			true
		)
			.then(() => {
				setIsLoading(false);
				getSalesContractDetailsInfo(salesContractId);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const onRequest = async () => {
		setIsLoading(true);
		await ApiClient.POST(
			'requestInvoice',
			{},
			orderId + `?entityId=${salesContractDetails.id}&documentType=SALES_CONTRACT`
		)
			.then(() => {
				setIsLoading(false);
				getSupplierList(orderId, true);
			})
			.catch(({ response }) => {
				setIsLoading(false);
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	const getOrderSummary = () => {
		return amendmentOrderSummary.length > 0
			? amendmentOrderSummary
			: salesContractDetails?.salesContractItemResponseList;
	};

	return (
		<LoaderComponent loading={isLoading || isMaterialListLoading}>
			{supplierList.length > 0 && salesContractDetails && (
				<div className="create-order-container mt-5">
					<div className="factory-slider pt-2">
						<OrderWiseSupplier
							supplierList={supplierList}
							onClick={onSalesContaractClick}
							details={salesContractDetails}
						/>
					</div>
					<div className="proforma-invoice-tab">
						{checkAnyUserType(['ADMIN', 'COMMERCIAL']) && (
							<div className="section-heading d-flex justify-content-end align-items-center">
								<div className="order-assigned-people align-items-center">
									<button className="button gray-outline size32 mr-0" onClick={onDownload}>
										Download SC
										<img
											src={`${process.env.PUBLIC_URL}/icons/download-dark-20.svg`}
											alt="download"
											className="ml-1"
										/>
									</button>
								</div>
							</div>
						)}
						<div className="invoice-info same-space d-flex ">
							<div className="d-flex invoice-left position-relative">
								<div className="sales-contract-heading pt-4">
									<h3 className="gray_dark_01 mt-2">SALES CONTRACT</h3>
								</div>
								{isEditContructDetails ? (
									<EditSalesContruct
										setIsEditSalesContruct={setIsEditContructDetails}
										onSalesContractDetailsInfo={getSalesContractDetailsInfo}
										salesContractDetails={salesContractDetails}
									/>
								) : (
									<div className="invoice-details w-100">
										{checkAnyUserType(['ADMIN', 'COMMERCIAL', 'FINANCE_AND_ACCOUNTS']) &&
											!isEditContructDetails && (
												<div className="d-flex justify-content-end mb-12">
													<img
														src={`${process.env.PUBLIC_URL}/icons/edit-black-20.svg`}
														alt="edit"
														className="cursor-pointer edit-action"
														onClick={() => setIsEditContructDetails(true)}
													/>
												</div>
											)}

										<p className="regular-14 gray_dark_02 mb-1">
											<span className="text-label">Sales contract No</span>
											<span className="">:</span>{' '}
											<span className="gray_dark_01">
												{salesContractDetails?.contractNo
													? salesContractDetails?.contractNo
													: '--'}
											</span>
										</p>
										<p className="regular-14 gray_dark_02 mb-1">
											<span className="text-label">Sales contract date</span>
											<span>:</span>{' '}
											<span className="gray_dark_01">
												{salesContractDetails?.contractDate
													? changeDateFormat(
															salesContractDetails?.contractDate,
															'YYYY-MM-DD',
															'DD-MMM-YYYY'
														)
													: '--'}
											</span>{' '}
										</p>
										<p className="regular-14 gray_dark_02 mb-1">
											<span className="text-label">Amendment</span>
											<span>:</span>{' '}
											<span className="gray_dark_01">
												{salesContractDetails?.amendmentNo
													? salesContractDetails?.amendmentNo
													: '--'}
											</span>
										</p>
										<p className="regular-14 gray_dark_02 mb-1">
											<span className="text-label">Amendment Date</span>
											<span>:</span>{' '}
											<span className="gray_dark_01">
												{salesContractDetails?.amendmentDate
													? changeDateFormat(
															salesContractDetails?.amendmentDate,
															'YYYY-MM-DD',
															'DD-MMM-YYYY'
														)
													: '--'}
											</span>
										</p>
									</div>
								)}
							</div>
							<div className="upload-files invoice-right d-flex">
								<div className="nitex-pi one-half">
									<p className="regular-14 gray_dark_02">Supplier signed PI</p>
									<div className="upload-pi-invoices d-flex align-items-center mt-1 ">
										<div className="upload-pi">
											<label
												htmlFor="supplier-signed-pi"
												className="drag-upload cursor-pointer d-flex mb-0 mr-2 pr-1"
											>
												<img
													src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`}
													alt="upload"
													className="upload-icon"
												/>
												<p className="regular-14 gray_dark_01 ml-1">Upload</p>
											</label>
											<input
												type="file"
												className="file-upload d-none"
												onClick={(e) => (e.target.value = null)}
												onChange={(e) => onFileUpload(e)}
												multiple={false}
												name="supplier-signed-pi"
												id="supplier-signed-pi"
												accept="*"
											/>
										</div>

										<div className="uploaded-pi mb-1">
											{salesContractDetails.supplierSignedPI &&
												Object.keys(salesContractDetails.supplierSignedPI).length !==
													0 && (
													<div
														className="chip-square-gray cursor-pointer"
														onClick={() =>
															window.open(
																salesContractDetails.supplierSignedPI?.docUrl,
																'_blank'
															)
														}
													>
														<Tooltip
															title={
																salesContractDetails.supplierSignedPI?.name
															}
															placement="top"
															arrow
														>
															<p className="regular-14 gray_dark_01">
																{getShortName(
																	salesContractDetails.supplierSignedPI
																		?.name,
																	10
																)}{' '}
																|{' '}
																{changeDateFormat(
																	salesContractDetails.supplierSignedPI
																		?.dateAdded,
																	'YYYY-MM-DD',
																	'DD MMM YY'
																)}
															</p>
														</Tooltip>
													</div>
												)}
										</div>
									</div>
									{checkAnyUserType(['ADMIN', 'ACCOUNT_MANAGER']) &&
										salesContractDetails?.supplierSignedPI &&
										Object.keys(salesContractDetails.supplierSignedPI).length !== 0 &&
										salesContractDetails?.approvalStatus === 'PENDING' && (
											<button className="button size32 mt-2" onClick={onRequest}>
												Send to commercial
											</button>
										)}
								</div>
								<div className="buyer-pi one-half">
									<p className="regular-14 gray_dark_02">Nitex signed SC</p>
									<div className="upload-pi-invoices d-flex align-items-center mt-1 ">
										{checkAnyUserType(['ADMIN', 'COMMERCIAL']) && (
											<div className="upload-pi">
												<label
													htmlFor="nitex-signed-pi"
													className="drag-upload cursor-pointer d-flex mb-0 mr-2 pr-1"
												>
													<img
														src={`${process.env.PUBLIC_URL}/icons/upload-dark.svg`}
														alt="upload"
														className="upload-icon"
													/>
													<p className="regular-14 gray_dark_01 ml-1">Upload</p>
												</label>
												<input
													type="file"
													className="file-upload d-none"
													onClick={(e) => (e.target.value = null)}
													onChange={(e) => onNitexScUpload(e)}
													multiple={false}
													name="nitex-signed-pi"
													id="nitex-signed-pi"
													accept="*"
												/>
											</div>
										)}
										<div className="uploaded-pi">
											{salesContractDetails.nitexSignedSC &&
												Object.keys(salesContractDetails.nitexSignedSC).length !==
													0 && (
													<div
														className="chip-square-gray cursor-pointer"
														onClick={() =>
															window.open(
																salesContractDetails.nitexSignedSC?.docUrl,
																'_blank'
															)
														}
													>
														<Tooltip
															title={salesContractDetails.nitexSignedSC?.name}
															placement="top"
															arrow
														>
															<p className="regular-14 gray_dark_01">
																{getShortName(
																	salesContractDetails.nitexSignedSC?.name,
																	10
																)}{' '}
																|{' '}
																{changeDateFormat(
																	salesContractDetails.nitexSignedSC
																		?.dateAdded,
																	'YYYY-MM-DD',
																	'DD MMM YY'
																)}
															</p>
														</Tooltip>
													</div>
												)}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="buyer-and-beneficiary-section with-title d-flex justify-content-between">
							<div className="one-half same-space">
								<div className="one-half-title">
									<h3 className="semibold-18 mb-0">BUYER</h3>
								</div>
								<div className="info-heading d-flex justify-content-between">
									<p className="semibold-14 mb-0">Billing</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle gray_dark_02 regular-14 pt-0"
												type="button"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												{selectedBuyerBillingAddress
													? selectedBuyerBillingAddress
													: 'Select address'}
												<img
													src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
													className="ml-2"
													alt="down"
												/>
											</button>
											<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
												{buyerBillingLits.map((item, index) => (
													<li
														className="px-4 pb-3 pt-3"
														key={salesContractDetails.id + index}
														onClick={() => {
															onUpdateBuyerBillingList(
																item,
																salesContractDetails.id
															);
															setSelectedBuyerBillingAddress(item.title);
														}}
													>
														<a href={void 0} className="gray_dark_02">
															{item.title}
														</a>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
								<div className="info-details">
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.billingAddress?.name}
									</p>
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.billingAddress?.address}
									</p>
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.billingAddress?.website}
									</p>
								</div>
							</div>
							<div className="one-half same-space">
								<div className="one-half-title">
									<h3 className="semibold-18 mb-0">BENEFICIARY</h3>
								</div>
								<div className="info-heading d-flex justify-content-between">
									<p className="semibold-14 mb-0">Beneficiary details</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle gray_dark_02 regular-14 pt-0"
												type="button"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												{selectedBeneficiaryDetails
													? selectedBeneficiaryDetails
													: 'Select address'}
												<img
													src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
													className="ml-2"
													alt="down"
												/>
											</button>
											<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
												{locationTypes.map((item) => (
													<li
														className="px-4 pb-3 pt-3"
														key={item.id}
														onClick={() => {
															onUpdateBeneficiaryDetails(
																item,
																salesContractDetails.id,
																item.type
															);
															setSelectedBeneficiaryDetails(item.type);
														}}
													>
														<a href={void 0} className="gray_dark_02">
															{item.name}
														</a>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
								<div className="info-details">
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.beneficiaryDetails?.title}
									</p>
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.beneficiaryDetails?.addressLine1}
									</p>
								</div>
							</div>
						</div>
						<div className="buyer-and-beneficiary-section d-flex justify-content-between">
							<div className="one-half same-space">
								<div className="info-heading d-flex justify-content-between">
									<p className="semibold-14 mb-0">Buyer bank details</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle gray_dark_02 regular-14 pt-0"
												type="button"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												{selectedBuyerBankDetails
													? selectedBuyerBankDetails
													: 'Select address'}
												<img
													src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
													className="ml-2"
													alt="down"
												/>
											</button>
											<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
												{nitexBankDetails.map((item) => (
													<li
														className="px-4 pb-3 pt-3"
														key={item.id}
														onClick={() => {
															onUpdateBuyerBankDetails(
																item,
																salesContractDetails.id
															);
															setSelectedBuyerBankDetails(item.title);
														}}
													>
														<a href={void 0} className="gray_dark_02">
															{item.bankName}
														</a>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
								<div className="info-details">
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.buyerBankDetails?.bankName}
									</p>
									<p className="regular-14 gray_dark_01">
										{salesContractDetails.buyerBankDetails?.bankDetails}
									</p>
									<p className="regular-14 gray_dark_01">
										<span>Swift:</span> {salesContractDetails.buyerBankDetails?.swiftCode}
									</p>
									<p className="regular-14 gray_dark_01">
										<span>A/C:</span>{' '}
										{salesContractDetails.buyerBankDetails?.accountNumber}
									</p>
								</div>
							</div>
							<div className="one-half same-space">
								<div className="info-heading d-flex justify-content-between">
									<p className="semibold-14 mb-0">Beneficiary bank details</p>
									<div className="option">
										<div className="dropdown">
											<button
												className="btn btn-default dropdown-toggle gray_dark_02 regular-14 pt-0"
												type="button"
												data-toggle="dropdown"
												aria-expanded="false"
											>
												{selectedBeneficiaryBankDetails
													? selectedBeneficiaryBankDetails
													: 'Select address'}
												<img
													src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
													className="ml-2"
													alt="down"
												/>
											</button>
											<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
												<li className="px-4 pb-3 pt-3">
													<a href={void 0} onClick={() => onAddBeneficiaryBank()}>
														<img
															src={`${process.env.PUBLIC_URL}/icons/add_primary.svg`}
															className="mr-2"
															alt="add"
														/>
														Add address
													</a>
												</li>
												{supplierBankDetailsList.map((item) => (
													<li
														className="px-4 pb-3 pt-3"
														key={item.id}
														onClick={() => {
															onUpdateBeneficiaryBankDetails(item);
															setSelectedBeneficiaryBankDetails(item.bankName);
														}}
													>
														<a href={void 0} className="gray_dark_02">
															{item.title}
														</a>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
								<div className="info-details">
									{salesContractDetails.beneficiaryBankDetails && (
										<>
											<p className="regular-14 gray_dark_01">
												{salesContractDetails.beneficiaryBankDetails?.bankName}
											</p>
											<p className="regular-14 gray_dark_01">
												{salesContractDetails.beneficiaryBankDetails?.bankDetails}
											</p>
											<p className="regular-14 gray_dark_01">
												<span>Swift:</span>{' '}
												{salesContractDetails.beneficiaryBankDetails?.swiftCode}
											</p>
											<p className="regular-14 gray_dark_01">
												<span>A/C:</span>{' '}
												{salesContractDetails.beneficiaryBankDetails?.accountNumber}
											</p>
										</>
									)}
								</div>
							</div>
						</div>

						{/* Notify */}
						<div className="buyer-and-beneficiary-section with-title d-flex justify-content-between">
							<div className="buyer-and-beneficiary-section d-flex justify-content-between">
								<div className="one-half same-space">
									<div className="one-half-title">
										<h3 className="semibold-18 mb-0">CONSIGNEE</h3>
									</div>
									<div className="info-heading d-flex justify-content-between">
										<p className="semibold-14 mb-0">Consignee details</p>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14 pt-0"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													{/* {selectedBuyerConsignee
														? selectedBuyerConsignee
														: 'Select address'} */}
													{getSelectedBuyerConsignee()}
													<img
														src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
														className="ml-2"
														alt="down"
													/>
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
													<li className="px-4 pb-3 pt-3">
														<a
															href={void 0}
															onClick={() => onAddConsigneeAddress()}
														>
															<img
																src={`${process.env.PUBLIC_URL}/icons/add_primary.svg`}
																className="mr-2"
																alt="add"
															/>
															Add address
														</a>
													</li>
													{brandLocationList.map((item) => (
														<li
															className="px-4 pb-3 pt-3"
															key={item.id}
															onClick={() => {
																onUpdateBuyerConsignee(
																	item.id,
																	salesContractDetails.id
																);
																setSelectedBuyerConsignee(item.id);
															}}
														>
															<a href={void 0} className="gray_dark_02">
																{item.title}
															</a>
														</li>
													))}
												</ul>
											</div>
										</div>
									</div>
									<div className="info-details">
										<p className="regular-14 gray_dark_01">
											{salesContractDetails.consignee?.title}
										</p>
										<p className="regular-14 gray_dark_01">
											{salesContractDetails.consignee?.addressLine1}
										</p>
										<p className="regular-14 gray_dark_01">
											{salesContractDetails.consignee?.addressLine2}
										</p>
										<p className="regular-14 gray_dark_01">
											{salesContractDetails.consignee?.state}
										</p>
										<p className="regular-14 gray_dark_01">
											{salesContractDetails.consignee?.city}
										</p>
										<p className="regular-14 gray_dark_01">
											{salesContractDetails.consignee?.countryName}
										</p>
									</div>
								</div>
								<div className="one-half same-space">
									<div className="one-half-title">
										<h3 className="semibold-18 mb-0">NOTIFY PARTY</h3>
									</div>
									<div className="info-heading d-flex justify-content-between">
										<p className="semibold-14 mb-0">Notify party details</p>
									</div>
									<div className="info-details">
										<textarea
											rows="6"
											type="text"
											autoComplete="off"
											id="termDetails"
											placeholder="Write notify party details"
											value={notifyParty}
											onChange={(e) => setNotifyParty(e.target.value)}
											onBlur={(event) => {
												if (!isValidInput(prevTarget, event)) {
													resetAll();
													return;
												}
												onUpdateSalesContact({ notifyParty: event.target.value });
											}}
										/>
									</div>
								</div>
							</div>
						</div>

						{/* Start Product & service details */}
						<div className="product-and-service-details">
							<div className="d-flex justify-content-between">
								<div className="title">
									<h3 className="semibold-18">ORDER SUMMARY</h3>
								</div>
								<div className="single-filter mb-3">
									<CustomDropdown
										title={'Amendment'}
										onItemClick={(item) => onSelectAmendment(item)}
										items={amendmentList}
										selectedItem={selectedAmendment?.amendmentNo}
									/>
								</div>
							</div>
							<div className="service-details-table order-sumamary-table">
								<table className="table">
									<thead>
										<tr>
											<th>
												<span className="semibold-14">SL</span>
											</th>
											<th>
												<span className="semibold-14">Reference</span>
											</th>
											<th>
												<span className="semibold-14">Description</span>
											</th>
											<th>
												<span className="semibold-14">Color</span>
											</th>
											<th>
												<span className="semibold-14">ETD</span>
											</th>
											<th>
												<span className="semibold-14">Qty</span>
											</th>
											<th>
												<span className="semibold-14">Unit price</span>
											</th>
											<th>
												<span className="semibold-14">Amount</span>
											</th>
										</tr>
									</thead>
									<tbody>
										{getOrderSummary().map((item, idx) => (
											<tr key={item.id}>
												<td>
													<span className="gray_dark_02">{idx + 1}</span>
												</td>
												{item.itemType === 'PRODUCT'
													? renderProductOrders(item)
													: renderOtherOrders(item, idx)}
											</tr>
										))}
										<tr>
											<td colSpan={2}>
												{/* <button
													className="button text pl-0"
													onClick={onAddNewProduct}
												>
													<span className="ml-1">Add row</span>
													<img src={`${process.env.PUBLIC_URL}/icons/add_primary.svg`} alt="add" />
												</button> */}
											</td>
											<td />
											<td />
											<td>
												<span className="semibold-14">Total:</span>
											</td>
											<td>
												<span className="semibold-14">
													{isNaN(parseInt(getItemTotal(getOrderSummary())))
														? 0
														: parseInt(getItemTotal(getOrderSummary()))}
												</span>
											</td>
											<td />
											<td>
												<span className="semibold-14">
													$
													{isNaN(
														parseFloat(getTotalAmount(getOrderSummary())).toFixed(
															2
														)
													)
														? ''
														: convertNumberToUSFormat(
																getTotalAmount(getOrderSummary())
															)}
												</span>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						{/* Terms and conditions */}
						<div className="product-and-service-details terms-and-conditions">
							<div className="title">
								<h3 className="semibold-18">TERMS AND CONDITIONS</h3>
							</div>
							<div className="service-details-table terms-and-conditions-table">
								<table className="table">
									<thead>
										<tr>
											<th></th>
											<th>
												<span className="semibold-14">SL</span>
											</th>
											<th>
												<span className="semibold-14">Title</span>
											</th>
											<th>
												<span className="semibold-14">Description</span>
											</th>
										</tr>
									</thead>
									<tbody>
										{salesContractDetails.termsAndConditionsResponseList?.map(
											(item, idx) => (
												<tr key={item.id}>
													<td>
														<div className="custom-chekbox">
															<div className="form-group m-0">
																<input
																	type="checkbox"
																	id={item.id}
																	name="terms"
																	checked={!item.isDeleted}
																/>
																<label
																	htmlFor="t2"
																	onClick={() => onChangeTerms(item)}
																/>
															</div>
														</div>
													</td>
													<td>
														<span className="gray_dark_02">{idx + 1}</span>
													</td>
													<td
														onClick={() => {
															setNewTermCellId(`${idx}-newItem`);
															setIsUpdateTerm(true);
														}}
													>
														{newTermCellId === `${idx}-newItem` ||
														(isAddNewTerm &&
															newTermCellId === `${idx}-newItem`) ? (
															<input
																type="text"
																autoComplete="off"
																id="term"
																value={item.term}
																onChange={(e) => onChangeAddNewTerms(e, idx)}
																onFocus={(event) =>
																	(prevTarget.current = event.target.value)
																}
																onBlur={(event) => {
																	if (!isValidInput(prevTarget, event)) {
																		resetAll();
																		return;
																	}
																	onAddTerms(item, idx);
																}}
																onKeyPress={(e) => {
																	if (e.key === 'Enter')
																		if (!isValidInput(prevTarget, e)) {
																			resetAll();
																			return;
																		}
																	onAddTerms(item, idx);
																}}
															/>
														) : (
															<span className="gray_dark_02">{item?.term}</span>
														)}
													</td>
													<td
														onClick={() => {
															setNewTermCellId(`${idx}-newItem`);
															setIsUpdateTerm(true);
														}}
													>
														{newTermCellId === `${idx}-newItem` ||
														(isAddNewTerm &&
															newTermCellId === `${idx}-newItem`) ? (
															item.term.trim() === 'DOCUMENT REQUIRED' ? (
																<textarea
																	rows="6"
																	type="text"
																	autoComplete="off"
																	id="termDetails"
																	value={item.termDetails}
																	onChange={(e) =>
																		onChangeAddNewTerms(e, idx)
																	}
																	onFocus={(event) =>
																		(prevTarget.current =
																			event.target.value)
																	}
																	onBlur={(event) => {
																		if (
																			!isValidInput(prevTarget, event)
																		) {
																			resetAll();
																			return;
																		}

																		onAddTerms(item, idx);
																	}}
																/>
															) : (
																<input
																	type="text"
																	autoComplete="off"
																	id="termDetails"
																	value={item.termDetails}
																	onChange={(e) =>
																		onChangeAddNewTerms(e, idx)
																	}
																	onFocus={(event) =>
																		(prevTarget.current =
																			event.target.value)
																	}
																	onKeyPress={(e) => {
																		if (e.key === 'Enter') {
																			if (
																				!isValidInput(prevTarget, e)
																			) {
																				resetAll();
																				return;
																			}
																			onAddTerms(item, idx);
																		}
																	}}
																	onBlur={(event) => {
																		if (
																			!isValidInput(prevTarget, event)
																		) {
																			resetAll();
																			return;
																		}
																		onAddTerms(item, idx);
																	}}
																/>
															)
														) : item.term.trim() === 'DOCUMENT REQUIRED' ? (
															<textarea
																rows="6"
																type="text"
																autoComplete="off"
																id="termDetails"
																value={item.termDetails}
																disabled
															/>
														) : (
															<span className="gray_dark_02">
																{item?.termDetails}
															</span>
														)}
													</td>
												</tr>
											)
										)}

										<tr>
											<td colSpan={4}>
												<button className="button text pl-0" onClick={onAddNewTerms}>
													<span className="ml-1">Add row</span>
													<img
														src={`${process.env.PUBLIC_URL}/icons/add_primary.svg`}
														alt="add"
													/>
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			)}
			{!isMaterialListLoading && supplierList.length === 0 && (
				<div className="create-order-container">
					<NoData message={'No supplier found'} />
				</div>
			)}
			{isAddBeneficiaryBank && (
				<AddBeneficiaryBankDetails
					onAddBeneficiaryBank={onAddBeneficiaryBank}
					selectedItem={salesContractDetails}
					getSalesContractDetailsInfo={getSalesContractDetailsInfo}
					isEditable={false}
					supplierId={salesContractDetails.supplierId}
				/>
			)}
			{isAddAddress && (
				<AddBuyerAddress
					onAddBuyerAddress={onAddConsigneeAddress}
					details={salesContractDetails}
					geDetailsInfo={getInvoiceDetailsInfo}
				/>
			)}
			{startLoader && <TimeBasedLoader startLoader={startLoader} />}
		</LoaderComponent>
	);
};

export default SalesContract;
